import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'eyrus-no-results-placeholder',
  templateUrl: './no-results-placeholder.component.html',
  styleUrls: ['./no-results-placeholder.component.sass']
})
export class NoResultsPlaceholderComponent implements OnInit {

  @Input() displaySub: Boolean = true;
  @Input() label: String = 'common.no-results-title';

  constructor() { }

  ngOnInit() {
  }

}
